import React from 'react';
import { Dropzone, useImageGenerate } from '@components';
import { Box } from '@mui/material';
import { PyrenzBlueButton } from '@client/theme';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { useNavigate } from 'react-router-dom';

interface ImageUploaderProps {
  onImageSelect: (input: string | File | Blob) => Promise<void>;
  initialImage?: string | null;
}

export function ImageUploader({ onImageSelect, initialImage }: ImageUploaderProps) {
  const navigate = useNavigate();
  const { previewUrl, setImage } = useImageGenerate();

  const handleDrop = async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (!file) return;
    setImage(file);
    await onImageSelect(file);
  };

  const handleGenerateClick = () => {
    navigate('/ImageGen');
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Dropzone
        onDrop={handleDrop}
        label="Drop image here Please (ᵕ—ᴗ—)"
        initialImage={previewUrl || initialImage || null}
        className="w-full mb-4"
      />

      <PyrenzBlueButton
        variant="contained"
        startIcon={<AddPhotoAlternateIcon />}
        onClick={handleGenerateClick}
      >
        Generate Image
      </PyrenzBlueButton>
    </Box>
  );
}
